export const media: { [key: string]: string } = {
    tablet: `@media (min-width: 768px)`,
    tablet_: `@media (min-width: 780px)`,
    desktop: `@media (min-width: 1280px)`,
    fulldesktop: `@media (min-width: 1680px)`,
    extrafulldesktop: `@media (min-width: 1920px)`,
};
